module.exports = __webpack_public_path__ + "static/media/medical-briefcase.87461d47.svg";